export default "__VITE_ASSET__dP6X2k81__"